const STORAGE_PREFIX = 'liverun.runnerFields.v1.'

export const runnerFieldPreferencePages = {
  allRunners: {
    storageKey: STORAGE_PREFIX + 'allRunners',
    fields: [
      { id: 'runner-id', label: 'Runner ID', group: 'Identity', defaultVisible: true, locked: true },
      { id: 'location', label: 'Location', group: 'Identity', defaultVisible: true },
      { id: 'gender', label: 'Gender', group: 'Identity', defaultVisible: true },
      { id: 'email', label: 'Email', group: 'Account', defaultVisible: true },
      { id: 'account-create', label: 'Account created', group: 'Account', defaultVisible: true },
      { id: 'facebook', label: 'Facebook', group: 'Account', defaultVisible: true },
      { id: 'website', label: 'Website', group: 'Account', defaultVisible: true },
      { id: 'trial-start', label: 'Trial start', group: 'Membership', defaultVisible: true },
      { id: 'trial-end', label: 'Trial end', group: 'Membership', defaultVisible: true },
      { id: 'promo-code', label: 'Promo code', group: 'Membership', defaultVisible: true },
      { id: 'promo-start', label: 'Promo start', group: 'Membership', defaultVisible: true },
      { id: 'promo-end', label: 'Promo end', group: 'Membership', defaultVisible: true },
      { id: 'height', label: 'Height', group: 'Profile', defaultVisible: true },
      { id: 'weight', label: 'Weight', group: 'Profile', defaultVisible: true },
      { id: 'profile-text', label: 'Profile text', group: 'Profile', defaultVisible: true },
      { id: 'total-completed-runs', label: 'Total completed runs', group: 'Run activity', defaultVisible: true },
      { id: 'last-liverun', label: 'Last LiveRun', group: 'Run activity', defaultVisible: true },
      { id: 'days-since-last-liverun', label: 'Days since last LiveRun', group: 'Run activity', defaultVisible: true }
    ]
  },
  completedRuns: {
    storageKey: STORAGE_PREFIX + 'completedRuns',
    fields: [
      { id: 'runner-id', label: 'Runner ID', group: 'Identity', defaultVisible: true, locked: true },
      { id: 'location', label: 'Location', group: 'Identity', defaultVisible: true },
      { id: 'gender', label: 'Gender', group: 'Identity', defaultVisible: true },
      { id: 'days-since-last', label: 'Days since last', group: 'Run activity', defaultVisible: true, locked: true },
      { id: 'email', label: 'Email', group: 'Account', defaultVisible: true },
      { id: 'account-create', label: 'Account create', group: 'Account', defaultVisible: true },
      { id: 'facebook', label: 'Facebook', group: 'Account', defaultVisible: true },
      { id: 'trial-start', label: 'Trial start', group: 'Membership', defaultVisible: true },
      { id: 'trial-end', label: 'Trial end', group: 'Membership', defaultVisible: true },
      { id: 'completed-runs', label: 'Completed runs', group: 'Run activity', defaultVisible: true },
      { id: 'last-liverun', label: 'Last LiveRun', group: 'Run activity', defaultVisible: true },
      { id: 'height', label: 'Height', group: 'Profile', defaultVisible: true },
      { id: 'weight', label: 'Weight', group: 'Profile', defaultVisible: true },
      { id: 'promo-code', label: 'Promo code', group: 'Membership', defaultVisible: true },
      { id: 'website', label: 'Website', group: 'Account', defaultVisible: true },
      { id: 'profile-text', label: 'Profile text', group: 'Profile', defaultVisible: true }
    ]
  },
  luckyLiveRunners: {
    storageKey: STORAGE_PREFIX + 'luckyLiveRunners',
    fields: [
      { id: 'race-date', label: 'Date', group: 'Run', defaultVisible: true },
      { id: 'run-start', label: 'Run Start', group: 'Run', defaultVisible: true },
      { id: 'run-name', label: 'Run Name', group: 'Run', defaultVisible: true },
      { id: 'trainer', label: 'Trainer', group: 'Run', defaultVisible: true },
      { id: 'runner-id', label: 'Runner ID', group: 'Runner', defaultVisible: true, locked: true },
      { id: 'runner-name', label: 'LiveRunner', group: 'Runner', defaultVisible: true },
      { id: 'sent-date', label: 'Sent', group: 'Gift', defaultVisible: true },
      { id: 'present-content', label: 'What', group: 'Gift', defaultVisible: true },
      { id: 'note', label: 'Note', group: 'Gift', defaultVisible: true },
      { id: 'actions', label: 'Actions', group: 'Management', defaultVisible: true, locked: true }
    ]
  }
}

function defaultFieldIds (fields) {
  return fields.filter(function (field) {
    return field.defaultVisible || field.locked
  }).map(function (field) {
    return field.id
  })
}

function lockedFieldIds (fields) {
  return fields.filter(function (field) {
    return field.locked
  }).map(function (field) {
    return field.id
  })
}

export function getDefaultRunnerFieldIds (fields) {
  return defaultFieldIds(fields)
}

export function sanitizeRunnerFieldIds (selectedIds, fields) {
  var validIds = fields.map(function (field) { return field.id })
  var lockedIds = lockedFieldIds(fields)
  var ids = Array.isArray(selectedIds) ? selectedIds : defaultFieldIds(fields)
  var sanitized = []

  ids.concat(lockedIds).forEach(function (id) {
    if (validIds.indexOf(id) !== -1 && sanitized.indexOf(id) === -1) {
      sanitized.push(id)
    }
  })

  if (sanitized.length === lockedIds.length) {
    var optionalSelected = sanitized.filter(function (id) {
      return lockedIds.indexOf(id) === -1
    })
    if (optionalSelected.length === 0) {
      return defaultFieldIds(fields)
    }
  }

  return sanitized
}

export function loadRunnerFieldPreference (storageKey, fields) {
  try {
    var saved = window.localStorage.getItem(storageKey)
    if (!saved) {
      return defaultFieldIds(fields)
    }
    return sanitizeRunnerFieldIds(JSON.parse(saved), fields)
  } catch (error) {
    return defaultFieldIds(fields)
  }
}

export function saveRunnerFieldPreference (storageKey, fields, selectedIds) {
  var sanitized = sanitizeRunnerFieldIds(selectedIds, fields)
  try {
    window.localStorage.setItem(storageKey, JSON.stringify(sanitized))
  } catch (error) {
    return sanitized
  }
  return sanitized
}

export function resetRunnerFieldPreference (storageKey, fields) {
  return saveRunnerFieldPreference(storageKey, fields, defaultFieldIds(fields))
}



// WEBPACK FOOTER //
// ./src/utils/runnerFieldPreferences.js